// extracted by mini-css-extract-plugin
export default {"heading":"CommentHeader_heading__04ROt"};